import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {LabelStyleProviderService} from "../../../../services/labelStylesProvider/label-style-provider.service";
import {BabyNumber} from "../BabyNumber";
import {ItemManagerService} from "../../../../services/itemManager/item-manager.service";
import {Item} from "../../../../models/Item";
import {CesiumAdapterService} from "../../../../services/cesiumAdapter21/cesium-adapter.service";

@Injectable({
  providedIn: 'root'
})
export class BabyAdapterService {

  private _babyCollection = new Map<any, {overlay, style, anchor}>();
  get babyCollection(){
    return this._babyCollection;
  }

  private _stylesList = new BehaviorSubject(null);
  get stylesList(){
    return this._stylesList.asObservable();
  }

  public anchorList = {
    TOP_LEFT        : "TOP_LEFT",
    TOP_CENTER      : "TOP_CENTER",
    TOP_RIGHT       : "TOP_RIGHT",
    CENTER_LEFT     : "CENTER_LEFT",
    CENTER          : "CENTER",
    CENTER_RIGHT    : "CENTER_RIGHT",
    BOTTOM_LEFT     : "BOTTOM_LEFT",
    BOTTOM_CENTER   : "BOTTOM_CENTER",
    BOTTOM_RIGHT    : "BOTTOM_RIGHT"
  };

  constructor(styleProvider: LabelStyleProviderService, private itemManager: ItemManagerService, private view: CesiumAdapterService) {
    styleProvider.getAll().then((styleList)=>{
      this._stylesList.next(styleList);
    });
    this.initListeners()
  }

  private initListeners(){  }

  public getBabyByItemId(id){
    return this._babyCollection.get(id);
  }

  public addToBabyCollection(id, babyObject:{overlay, style, anchor}){
    this._babyCollection.set(id, babyObject);
  }

  public getBabyStyle(id){
    return (this.getBabyByItemId(id)) ? this.getBabyByItemId(id).style : null;
  }

  getBabyAnchor(id){
    return (this.getBabyByItemId(id)) ? this.getBabyByItemId(id).anchor : null;
  }

  public setBabyStyle(id, style){
    let elm:{overlay:BabyNumber, style, anchor} = this.getBabyByItemId(id);
    elm.style = style;
    this.addToBabyCollection(id, elm);
    this.updateSubject(id, elm)
  }

  public setBabyAnchor(id, anchor){
    let elm:{overlay, style, anchor} = this.getBabyByItemId(id);
    elm.anchor = anchor;
    this.addToBabyCollection(id, elm);
    this.updateSubject(id, elm)
  }

  private updateSubject(id, elm){
    let item = this.itemManager.getItemById(id);
    item.getSubject(Item.BABY_SUBJECT).next(elm);
  }
}
